import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
} from '@mui/material';
import HeaderAndSidebar from 'components/templates/HeaderAndSidebar';
import { useState } from 'react';
import { Vehicle, VehicleKind } from 'types';

type Props = {
  isLoading: boolean;
  onSubmit: (vehicle: Vehicle) => void;
};

const NewVehicle: React.FC<Props> = ({ isLoading, onSubmit }) => {
  const [name, setName] = useState('');
  const [kind, setKind] = useState<VehicleKind>('normal_car');
  const [totalMileage, setTotalMileage] = useState(0);
  const [files, setFiles] = useState<FileList | null>(null);

  const handleSubmit = () => {
    if (!files) return;

    const file = files[0];
    if (!file) return;

    const fileReader = new FileReader();
    fileReader.onload = () => {
      if (!fileReader.result) return;
      if (typeof fileReader.result !== 'string') return;

      const vehicle: Vehicle = {
        name,
        kind,
        id: -1,
        image: fileReader.result,
        total_mileage: totalMileage,
        average_fuel_consumption: 0,
        forecast_work_mileage: 0,
        forecast_next_refuel_total_mileage: 0,
      };
      onSubmit(vehicle);
    };
    fileReader.readAsDataURL(file);
  };

  return (
    <HeaderAndSidebar pageTitle="燃費計算">
      {isLoading ? (
        <CircularProgress />
      ) : (
        <Grid item xs={12} md={12} lg={12}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Box component="form" noValidate sx={{ mt: 1 }}>
              <Stack spacing={3} maxWidth={400}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(event) => setFiles(event.target.files)}
                />
                <TextField
                  margin="normal"
                  required
                  label="名前"
                  name="name"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
                <Select
                  label="種別"
                  name="kind"
                  autoWidth
                  value={kind}
                  onChange={(event) =>
                    setKind(event.target.value as VehicleKind)
                  }
                >
                  <MenuItem value="normal_car">普通自動車</MenuItem>
                  <MenuItem value="motorcycle50">原付</MenuItem>
                </Select>
                <TextField
                  margin="normal"
                  required
                  label="総走行距離"
                  name="total_mileage"
                  value={totalMileage}
                  inputProps={{ min: 0, step: 0.1 }}
                  onChange={(event) =>
                    setTotalMileage(parseFloat(event.target.value))
                  }
                />
                <Button
                  type="button"
                  variant="contained"
                  sx={{ maxWidth: '64px' }}
                  onClick={handleSubmit}
                >
                  追加
                </Button>
              </Stack>
            </Box>
          </Paper>
        </Grid>
      )}
    </HeaderAndSidebar>
  );
};

export default NewVehicle;
